export const defaultContentGrid = {
    start: [1, null, null, 2],
    end: [13, null, null, 12],
};
export const smallContentGrid = {
    start: [1, null, null, 2, 3],
    end: [13, null, null, 12, 11],
};
